'use client';
import { useEffect } from 'react';
import { Box, Button, Typography } from '@mui/material';

type ErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  const handleReset = () => {
    reset();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Typography variant="h4" gutterBottom fontWeight="bold" color="error">
        Something went wrong!
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        We apologize for the inconvenience. An unexpected error has occurred in the application.
      </Typography>
      <Button variant="contained" onClick={handleReset} sx={{ borderRadius: 2, px: 4 }}>
        Try again
      </Button>
    </Box>
  );
}
